﻿import $ from "jquery";

function WinxnetUtility(url, ajaxUrl) {
    this._url = url;
    this._ajaxUrl = ajaxUrl;
    this._modifiedItems = {};
};

WinxnetUtility.prototype = {
    getAllModifiedItems: function () {
        var modifiedItems = this._modifiedItems;
        var items = {};
        for (var key in modifiedItems) {
            if (key) {
                items[key] = modifiedItems[key];
            }
        }
        return items;
    },
    getModifiedItems: function(itemType) {
        var mod = this._modifiedItems[itemType];
        if (mod) {
            return mod;
        }
        return [];
    },
    shouldBeArray: function(thing) {
        // if we have an object that is { 1: something, 2: something ... } then we could convert it into an array
        if ($.type(thing) !== 'object') {
            return false;
        }

        for (prop in thing) {
            if (!$.isNumeric(prop)) {
                return false;
            }
        }
        return true;
    },
    convertToArray: function(convert) {
        if ($.isArray(convert)) {
            return convert;
        }
        var array = [];

        for (var idx in convert) {
            if (idx) {
                array.push(convert[idx]);
            }
        }
        return array;
    },
    storeModifiedItem: function (itemType, item, triggerDirty) {

        if (typeof triggerDirty == 'undefined') {
            triggerDirty = true;
        }

        var itemIdx = -1;
        var modifiedItems = this._modifiedItems[itemType];
        if (!modifiedItems) {
            this._modifiedItems[itemType] = modifiedItems = [];
        }

        if (!item.uid) {
            // Kendo models have a uid already. We can create our own here if we're not using kendo modles
            item.uid = this.newGuid();
        }

        $.each(modifiedItems, function (idx, element) {
            if (element.uid == item.uid) {
                itemIdx = idx;
                return false;
            }
        });

        if (itemIdx >= 0) {
            if (item.IsNew && item.IsDeleted) {
                modifiedItems.splice(itemIdx, 1);
            } else {
                modifiedItems[itemIdx] = item;
            }
        } else {
            modifiedItems.push(item);
        }

        if (triggerDirty) {
            this.makeDirty();
        }

        return item;
    },
    registerSave: function (selector, save) {
        'use strict';

        if (!$.isFunction(save)) {
            throw 'api.registerSave expected save to be a function';
        }
        var saveContext = this.getSave(selector);
        saveContext.push({ save: save });
    },
    registerSaveModifiedItems: function(options) {
    'use strict';
    var that = this;
    var saveContext = that.getSave(options.formSelector);
    saveContext.push({
        save: function(selector) {
            $(selector).append(that.createFormKeyItemDictionary(that.getModifiedItems(options.itemType), options.collectionName, options.keyProperty));
        }
    });
    },
    logWarn: function (message) {
        if (window.console && window.console.warn) {
            console.warn(message);
        }
    },
    navigateToUrl: function(controller, action, id, querystring) {
        var method = controller + '/' + action;
        if (id) {
            method += '/' + id;
        }
        if (querystring) {
            method += '?' + querystring;
        }
        window.location = method;
    },
    constructUrl: function (method, useApi) {
        var url;
        if (useApi) {
            url = api._baseApiUrl;
        } else {
            url = api._baseUrl;
        }
        return url + method;
    },
    makeDirty: function () {
        $('form:not(.ignoredirty)').addClass('dirty');
    },
    getSave: function (selector) {
        'use strict';
        var context;

        if (selector) {
            context = $(selector).closest('.savecontext');

            if (context.length == 0) {
                context = $(selector).closest('form:not(.ignoresave)').first();
                context.addClass('savecontext'); // no .savecontext found, we'll create our own on for this form.
            }
        } else {
            context = $('.savecontext');

            if (context.length == 0) {
                // if we can't find a save context, create one on the first form on the page
                var form1 = $('form:not(.ignoresave)').first();
                if (form1.length > 0) {
                    form1.addClass('savecontext');
                    context = form1;
                }
            }
        }

        if (context.length == 0) {
            this.logWarn("Can't use api save context: no .savecontext found for selector: " + selector);
            return [];
        }

        var save = context.data('save');
        if (!save) {
            save = [];
            context.data('save', save);
        }
        return save;
    },
    createFormForObject: function (o, name, indexArrays) {
        // returns a string of hidden inputs so we can post back a client model that form input elements do not already exist for.
        // Complex child objects that are arrays or array-like (according to api.shouldBeArray) will get the createFormKeyItemDictionary treatment.
        if (!o) {
            return '';
        }
        var util = this,
            form = '',
            template = '<input class="apitransient" type="hidden" name="#= name #" value="#= value #"></input>',
            ctemplate = kendo.template(template);
        for (prop in o) {
            var value = o[prop];
            var postAs;
            if (indexArrays) {
                postAs = name + '[' + prop + ']';
            } else {
                postAs = name + '.' + prop;
            }
            if (value) {
                value = util.removeKendoModelProperties(value);
                if (util.shouldBeArray(value)) {
                    value = util.convertToArray(value);
                }
                if ($.isArray(value)) {
                    form += util.createFormKeyItemDictionary(value, postAs);
                } else if (typeof (value) == 'object') {
                    form += util.createFormForObject(value, postAs);
                } else {
                    form += ctemplate({
                        name: postAs,
                        value: value
                    });
                }
            }
        }

        return form;
    },
    removeKendoModelProperties: function(model) {
        if (model && $.isFunction(model.toJSON)) {
            model = model.toJSON(); // this is a kendo model: convert it to a simpler object which removes their infrastructure properties
        }
        return model;
    },
    createFormKeyItemDictionary: function (array, collectionName, keyProperty) {
        'use strict';
        // this function will return a string of hidden inputs
        // using the format discussed in http://www.hanselman.com/blog/ASPNETWireFormatForModelBindingToArraysListsCollectionsDictionaries.aspx
        // for posting up KeyItemCollections. 

        var util = this;
        var dictionary = util.createKeyItemDictionary(array, keyProperty);

        var form = '';
        var template = '<input class="apitransient" type="hidden" name="#= collectionName #[#= index #].#= property #" value="#= value #"></input>';
        var ctemplate = kendo.template(template);

        function iterateObject(idx, values, parentProp) {
            values = util.removeKendoModelProperties(values);

            for (var property in values) {

                var value = util.removeKendoModelProperties(values[property]);

                if (property.substring(0, 1) != '_' && !$.isFunction(value)) {
                    if (util.shouldBeArray(value)) {
                        value = util.convertToArray(value);
                    }
                    if ($.isArray(value)) {
                        for (var arrayIdx in value) {
                            if (!value[arrayIdx].Key || !value[arrayIdx].Value) {
                                // if array items are not already key value pairs, transform them 
                                value = util.createKeyItemDictionary(value, keyProperty);
                            }
                            break;
                        }
                        $.each(value, function (i, v) {
                            iterateObject(idx, v, parentProp + '.' + property + '[' + i + ']');
                        });
                    } else if (typeof (value) == 'object') {
                        if (property != 'defaults' && property != 'fields') { // kendo model fields to be ignored
                            iterateObject(idx, value, parentProp + '.' + property);
                        }
                    } else {
                        var propertyName;

                        if (parentProp) {
                            propertyName = 'Value' + parentProp + '.' + property;
                        } else {
                            propertyName = 'Value.' + property;
                        }

                        form += ctemplate({
                            collectionName: collectionName,
                            index: idx,
                            property: propertyName,
                            value: value
                        });
                    }
                }
            }
        }

        $.each(dictionary, function (idx, item) {
            if (item) {
                form += ctemplate({ collectionName: collectionName, index: idx, property: 'Key', value: item.Key });
                iterateObject(idx, item.Value, '');
            }
        });
        return form;
    },
    createKeyItemDictionary: function(array, keyProperty) {
    'use strict';

    var r = [];

    if (array) {
        // array here might not be a real array... but we're going to treat it like one.
        var newKey = 0,
            counter = 0;
        if (!keyProperty) {
            keyProperty = 'Key';
        }
        $.each(array, function(idx, val) {
            var key = val[keyProperty];
            if (!key || key == 0) {
                key = --newKey;
            }
            if ($.isFunction(val.toJSON)) {
                val = val.toJSON();
            }
            r[counter++] = { Key: key, Value: val };
        });
    }

    return r;
    },
    createModifiedItemsFormElementCollection: function () {
        var util = this;
        var allModifiedItems = util.getAllModifiedItems();
        var formElements = '';
        for (var collectionName in allModifiedItems) {
            if (collectionName) {
                formElements += util.createFormKeyItemDictionary(allModifiedItems[collectionName], collectionName);
            }
        }
        return formElements;
    },
    calculateDateOffset: function(startDate, offSet) {
        var date = moment(startDate);
        return date.add(offSet, 'days').toDate();
    },
    calculateLastDateOfRange: function(startDate, offset) {
        return this.calculateDateOffset(startDate, offset - 1);
    },
    convertTimeTo24h: function(timeString) {
        return moment(timeString, 'h:mm A').format("HH:mm");
    },
    convertTimeTo12h: function (timeString) {
        return moment(timeString, 'HH:mm').format("h:mm A");
    },
    setAlternateSaveFunction: function(fcn) {
        var that = this;
        this.alternateSaveFunction = fcn;
    },
    getLookupProperty: function(array, id, property) {
        var that = this;
        var val = '';

        if (id) {
            var items = array.filter(function (item) {
                return (property in item && item.Value == id);
            });
            if (items.length > 0) {
                return items[0][property];
            }
        }
        return val;
    },
    getLookupSupplementalText: function (array, id) {
        var that = this;
        return that.getLookupProperty(array, id, 'SupplementalText');
    },
    getLookupText: function (array, id) {
        var that = this;
        return that.getLookupProperty(array, id, 'Text');
    },


    getNameForGridLookup: function(value, collection) {
        var returnValue = "text not found for:" + value;
        angular.forEach(collection, function(store) {
            if (store.Value == value) {
                returnValue = store.Text;
                return false; //break
            }
        });
        return returnValue;
    },
    populateGridDropdownItems: function (editEvent, inputName, gridName, columnName, dataSource, includeEmpty) {
        var container = editEvent.container;
        var existingInput = container.find("input[name='" + inputName + "']");
        var grid = $('[data-grid-id="' + gridName + '"').data().kendoGrid;


        //need to remove already selected items from the drop down. however, if in edit mode, leave the existing item ******
        var currentId = -1;
        var ctx = editEvent.container.context; // will be null for add event, valid for edit event
        var isNew = true;
        if (ctx) {
            isNew = false;
            var cls = editEvent.container.context.className;
            if (cls.indexOf('edit') > -1) {
                var dataItem = grid.dataItem(editEvent.container);
                currentId = dataItem.get(columnName);
            }
        }

        var items = grid.dataSource.data();        
        var availableItems = JSON.parse(JSON.stringify(dataSource));
        for (var i = 0; i < items.length; i++) {
            for (var j = 0; j < availableItems.length; j++) {
                var itm = availableItems[j];
                var remove = false;
                if (
                       (itm.Value == items[i][columnName]) &&
                       (itm.Value != currentId)
                    ) {
                    remove = true;
                } else if (isNew && itm.Inactive) {
                    remove = true;
                }


                if (remove) {
                    availableItems.splice(j, 1);
                }

            }
        }

            //*******************************************************************************************************************
        
        
        var ddl = existingInput
                .kendoDropDownList({
                    //optionLabel: "Select ...",
                    dataTextField: 'Text',
                    dataValueField: 'Value',
                    dataSource: {
                        data: availableItems
                    },
                    index: 1
                    
                }).data('kendoDropDownList');

        if (isNew && availableItems.length > 0) {

            ddl.select(0);
            ddl.trigger('change');
        }
        

    }


}

export default WinxnetUtility;
